import { Col } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { InsurerIntegrationProvider } from '../../../../api/types';
import SelectField from '../../../../components/fields/SelectField';
import useSystemOptions from '../../../../utilities/useSystemOptions';
import EazyInsurerIntegration from './EazyInsurerIntegration';
import EmailInsurerIntegration from './EmailInsurerIntegration';

export type InsurerIntegrationFieldsProps = {
    isUpdate: boolean;
    provider: InsurerIntegrationProvider;
    compact?: boolean;
    nested: boolean;
    disabled?: boolean;
};

const DEFAULT_COL_SPAN = { lg: 8, md: 12, xs: 24 };
const COMPACT_COL_SPAN = { lg: 24, md: 24, sm: 24, xs: 24 };

const InsurerIntegrationFields = ({
    isUpdate,
    provider,
    compact = false,
    nested,
    disabled = false,
}: InsurerIntegrationFieldsProps) => {
    const { t } = useTranslation(['insurerDetails']);

    const { insurerIntegrationProviderOptions } = useSystemOptions();
    const colSpan = useMemo(() => (compact ? COMPACT_COL_SPAN : DEFAULT_COL_SPAN), [compact]);

    return (
        <>
            {!isUpdate && (
                <Col {...colSpan}>
                    <SelectField
                        {...t('insurerDetails:fields.integrationProvider', { returnObjects: true })}
                        disabled={disabled}
                        name="integrationProvider"
                        options={insurerIntegrationProviderOptions}
                        required
                        showSearch
                    />
                </Col>
            )}
            {provider === InsurerIntegrationProvider.Email && (
                <EmailInsurerIntegration
                    colSpan={colSpan}
                    disabled={disabled}
                    prefix={isUpdate ? 'integration' : 'integrationSettings.email'}
                />
            )}

            {provider === InsurerIntegrationProvider.Eazy && (
                <EazyInsurerIntegration
                    colSpan={colSpan}
                    disabled={disabled}
                    prefix={isUpdate ? 'integration' : 'integrationSettings.eazy'}
                />
            )}
        </>
    );
};

export default InsurerIntegrationFields;
